/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Elegant_Next_Slug_BorrowInputs */

const fr_elegant_next_slug_borrow = /** @type {(inputs: Elegant_Next_Slug_BorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau Cours`)
};

/**

* @param {Elegant_Next_Slug_BorrowInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const elegant_next_slug_borrow = /** @type {((inputs?: Elegant_Next_Slug_BorrowInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Elegant_Next_Slug_BorrowInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_elegant_next_slug_borrow(inputs)
});